import { ACH, AFFIRM, BACS, KLARNA, PADS, SEPA } from 'payments-checkout-lib/constants/PaymentElement';
import { RECAPTCHA_ACH_TYPE, RECAPTCHA_AFFIRM_TYPE, RECAPTCHA_BACS_TYPE, RECAPTCHA_CARD_TYPE, RECAPTCHA_KLARNA_TYPE, RECAPTCHA_PADS_TYPE, RECAPTCHA_SEPA_TYPE } from '../constants/ReCaptcha';
export const getRecaptchaActionForPaymentMethod = paymentMethod => {
  switch (paymentMethod) {
    case ACH:
      return RECAPTCHA_ACH_TYPE;
    case BACS:
      return RECAPTCHA_BACS_TYPE;
    case PADS:
      return RECAPTCHA_PADS_TYPE;
    case SEPA:
      return RECAPTCHA_SEPA_TYPE;
    case AFFIRM:
      return RECAPTCHA_AFFIRM_TYPE;
    case KLARNA:
      return RECAPTCHA_KLARNA_TYPE;
    default:
      return RECAPTCHA_CARD_TYPE;
  }
};